import { render, staticRenderFns } from "./MortgageItemCloud.vue?vue&type=template&id=16d0a891&scoped=true&"
import script from "./MortgageItemCloud.vue?vue&type=script&lang=js&"
export * from "./MortgageItemCloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d0a891",
  null
  
)

export default component.exports